import React, {Component} from 'react';
import localDB from "../../data/localDB";
import ClientData from "../../data/ClientData";
import DynamicTable from "../extras/DynamicTable";
import {clientDialog} from "../../actions/ClientDialogAction";
import {showToast} from "../../actions/ToastAction";
import {dynamicTableAddOrUpdate, dynamicTableDelete} from "../../actions/DynamicTableDataAction";
import connect from "react-redux/es/connect/connect";
import {withRouter} from "react-router-dom";
import QuestionDialog from "../extras/QuestionDialog";
import {ws_store} from "../sockets/SocketStore";

class ClientList extends Component {

    constructor() {
        super();
        this.state = {
            table: {
                headers: ['Identificación', 'Cliente', 'Teléfono', 'Email', 'Acciones'],
                name: 'Cliente',
                title: 'Clientes',
                has_actions: true,
                edit: true,
                can_add: true,
                pagination: true,
                delete: true,
                navigate: localDB.get('store_security').can_view_customer_details,
                url: 'clients',
                values: ['id', 'identification', 'full_name', 'phone', 'email'],
                id: 'table_report_clients'
            },
        };

        this.delete = this.delete.bind(this);
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.select_client && nextProps.select_client.hasOwnProperty('id')){
            this.props.dynamicTableAddOrUpdate(nextProps.select_client);
        }
    }

    async delete(id) {
        ClientData.delete(id, (res) => {
            if (res === null) {
                this.props.dynamicTableDelete(id);
                localDB.deleteDB('clients', id);
                this.props.showToast({message: 'Cliente Borrado!', type: 'success'});
                ws_store.send(JSON.stringify({
                    id,
                    payload: {
                        type: 'client',
                        action: 'delete',
                        sender: localDB.get('user').username
                    }
                }));

            } else {
                this.props.showToast({message: 'Tenemos un problema!', type: 'error'});
            }
        });
    };

    callbackDynamicTable = (response) => {
        if(response.event === 'add'){
            this.props.clientDialog({open:true, client:{id:null}});
        }else if(response.event === 'edit'){
            this.props.clientDialog({open:true, client:response.data});
        }else if(response.event === 'delete'){
            this.refs.deleteDialog.open('', response.data.id);
        }else if(response.event === 'navigate'){
            localDB.set('current_client', response.data);
            this.props.history.push(`/reports/clients/${response.data.id}`);
        }
    };

    render() {
        return (
            <div>
                <DynamicTable {...this.state.table} callbackDynamicTable={this.callbackDynamicTable}/>
                <QuestionDialog ref="deleteDialog" message="borrar este cliente" callbackConfirm={this.delete}/>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        select_client: state.get('select_client'),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        clientDialog(client){
            dispatch(clientDialog(client))
        },
        showToast(data){
            dispatch(showToast(data))
        },
        dynamicTableDelete(data){
            dispatch(dynamicTableDelete(data))
        },
        dynamicTableAddOrUpdate(data){
            dispatch(dynamicTableAddOrUpdate(data))
        },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(ClientList));



// WEBPACK FOOTER //
// ./src/components/contacts/ClientList.js